import { render, staticRenderFns } from "./LeaderList.vue?vue&type=template&id=9ed8db46"
import script from "./LeaderList.vue?vue&type=script&lang=js"
export * from "./LeaderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports